export const MINDMAP_VISUAL_THEMES = [
  'colorful',
  'vintage',
  'blast',
  'prism',
  'aquarelle',
  'sunny',
  'ocean',
  'pastel',
  'bubble',
] as const;

export type MindmapVisualTheme = (typeof MINDMAP_VISUAL_THEMES)[number];

const COLORFUL_PALETTE = [
  '#4070FF',
  '#FF6B00',
  '#00AAFF',
  '#92D63F',
  '#D01F2E',
  '#2ED7D8',
  '#FF3D6E',
  '#3DCC3D',
  '#00E5FF',
  '#7C3AED',
  '#FFD426',
  '#00C2A8',
  '#96DB0B',
  '#A179F2',
  '#F7578C',
  '#FFAA00',
  '#00D67A',
  '#FF2D95',
  '#7A9B05',
  '#FFB300',
  '#00B7FF',
] as const;

const SUNNY_PALETTE = [
  '#FF6B00',
  '#FF8A00',
  '#FFAA00',
  '#FFD426',
  '#FFE45C',
  '#D01F2E',
  '#FF3D6E',
  '#F7578C',
  '#FF2D95',
  '#C43DCE',
  '#7C3AED',
  '#5868F8',
  '#00AAFF',
  '#00C2A8',
  '#00D67A',
  '#96DB0B',
] as const;

const PASTEL_PALETTE = [
  '#A8C4F7',
  '#F5C19A',
  '#A4DDF2',
  '#B9DCA6',
  '#F2ABB6',
  '#A7E3D6',
  '#F3B4D1',
  '#B4E3C1',
  '#C4B4EF',
  '#F6DE9A',
  '#D9C4EE',
  '#F4C7A8',
  '#B5D8F4',
  '#D1C99A',
  '#E8C4A0',
  '#BFC7E8',
] as const;

export const MINDMAP_THEME_PALETTES: Readonly<
  Record<MindmapVisualTheme, readonly string[]>
> = {
  colorful: COLORFUL_PALETTE,
  vintage: COLORFUL_PALETTE,
  blast: COLORFUL_PALETTE,
  prism: COLORFUL_PALETTE,
  aquarelle: [
    '#B96957',
    '#D77A68',
    '#F0998A',
    '#A85F4B',
    '#D8C36A',
    '#A9B879',
    '#6FAE9C',
    '#89BAC6',
    '#5D9FB2',
    '#6B899E',
    '#6576A4',
    '#8C78A8',
    '#A66E8A',
    '#C78C6A',
    '#956955',
    '#34495E',
  ],
  sunny: SUNNY_PALETTE,
  ocean: ['#5868F8', '#94D600', '#49A6F6', '#4BCA37', '#57D8E3'],
  pastel: PASTEL_PALETTE,
  bubble: PASTEL_PALETTE,
};
